<template>
	<div>
		<!-- 隐私政策 -->
		<div class="mobileAgree">
			<div class="text_content">
				<h3>隐私政策</h3>
				<div class="mobile-agree-content">
					<p v-for="(item,i) in formattedContent('privacyContent')" :key="i">
						{{item}}
					</p>
				</div>
			</div>
		</div>
		
	</div>
</template>
<script>
	export default {
		name: "confidentiality",
		data() {
			return {
				privacyContent:''
		
			}
		},
		mounted() {
			this.getTxtFile('隐私政策', 'privacyContent')
		
		},
		methods: {
			formattedContent(keysName) {
				return this[keysName]
					.split(/\r?\n/)
					.filter((segment) => segment.trim());
			},
			async getTxtFile(fileName, keysName) {
				try {
					const response = await fetch("/txt/" + fileName + ".txt");
					const text = await response.text();
		
					// 判断是否有内容
					if (text && text.trim()) {
						this[keysName] = text;
						console.log("文件有内容:");
					} else {
						this[keysName] = "";
						console.log("文件内容为空");
					}
		
				} catch (error) {
					console.error("读取文件失败:", error);
				}
			}
		}
	}
</script>
<style scoped>
	.content {
		width: 100%;
	}

	.agreement {
		padding: 0 20px;
	}

	.agreement h3 {
		text-align: center;
		font-size: 22px;
		line-height: 48px;
		color: #000;
		font-weight: bold;
	}

	.agreement p {
		font-size: 14px;
		color: #000;
		line-height: 28px;
		text-align: justify;
		text-indent: 28px;
	}

	.agreement h5 {
		font-size: 14px;
		color: #000;
		line-height: 28px;
		text-align: justify;
	}

	.agreement h4 {
		text-align: left;
		font-size: 18px;
		line-height: 40px;
		color: #000;
		font-weight: bold;
	}
</style>